/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnresolvedVendorErrorCodeStatus } from './UnresolvedVendorErrorCodeStatus';
import {
    UnresolvedVendorErrorCodeStatusFromJSON,
    UnresolvedVendorErrorCodeStatusFromJSONTyped,
    UnresolvedVendorErrorCodeStatusToJSON,
    UnresolvedVendorErrorCodeStatusToJSONTyped,
} from './UnresolvedVendorErrorCodeStatus';
import type { VendorErrorCategory } from './VendorErrorCategory';
import {
    VendorErrorCategoryFromJSON,
    VendorErrorCategoryFromJSONTyped,
    VendorErrorCategoryToJSON,
    VendorErrorCategoryToJSONTyped,
} from './VendorErrorCategory';
import type { VendorErrorCodeManufacturerSummaryDto } from './VendorErrorCodeManufacturerSummaryDto';
import {
    VendorErrorCodeManufacturerSummaryDtoFromJSON,
    VendorErrorCodeManufacturerSummaryDtoFromJSONTyped,
    VendorErrorCodeManufacturerSummaryDtoToJSON,
    VendorErrorCodeManufacturerSummaryDtoToJSONTyped,
} from './VendorErrorCodeManufacturerSummaryDto';
import type { VendorErrorParameter } from './VendorErrorParameter';
import {
    VendorErrorParameterFromJSON,
    VendorErrorParameterFromJSONTyped,
    VendorErrorParameterToJSON,
    VendorErrorParameterToJSONTyped,
} from './VendorErrorParameter';
import type { VendorErrorState } from './VendorErrorState';
import {
    VendorErrorStateFromJSON,
    VendorErrorStateFromJSONTyped,
    VendorErrorStateToJSON,
    VendorErrorStateToJSONTyped,
} from './VendorErrorState';
import type { VendorErrorCodeAssetTypeSummaryDto } from './VendorErrorCodeAssetTypeSummaryDto';
import {
    VendorErrorCodeAssetTypeSummaryDtoFromJSON,
    VendorErrorCodeAssetTypeSummaryDtoFromJSONTyped,
    VendorErrorCodeAssetTypeSummaryDtoToJSON,
    VendorErrorCodeAssetTypeSummaryDtoToJSONTyped,
} from './VendorErrorCodeAssetTypeSummaryDto';
import type { VendorErrorImpactedComponent } from './VendorErrorImpactedComponent';
import {
    VendorErrorImpactedComponentFromJSON,
    VendorErrorImpactedComponentFromJSONTyped,
    VendorErrorImpactedComponentToJSON,
    VendorErrorImpactedComponentToJSONTyped,
} from './VendorErrorImpactedComponent';
import type { VendorErrorSeverity } from './VendorErrorSeverity';
import {
    VendorErrorSeverityFromJSON,
    VendorErrorSeverityFromJSONTyped,
    VendorErrorSeverityToJSON,
    VendorErrorSeverityToJSONTyped,
} from './VendorErrorSeverity';

/**
 * 
 * @export
 * @interface UnresolvedVendorErrorCodeResponseDto
 */
export interface UnresolvedVendorErrorCodeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    manufacturerId: string;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    assetTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    errorCode: string;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    matchType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    matchKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    vendorErrorCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    info?: string | null;
    /**
     * 
     * @type {VendorErrorParameter}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    parameter?: VendorErrorParameter | null;
    /**
     * 
     * @type {VendorErrorState}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    state?: VendorErrorState | null;
    /**
     * 
     * @type {VendorErrorImpactedComponent}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    impactedComponent?: VendorErrorImpactedComponent | null;
    /**
     * 
     * @type {VendorErrorCategory}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    category?: VendorErrorCategory | null;
    /**
     * 
     * @type {VendorErrorSeverity}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    severity?: VendorErrorSeverity | null;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    firmwareVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    sourceDescription?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    firstSeenAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    lastSeenAt: Date;
    /**
     * 
     * @type {number}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    occurrenceCount: number;
    /**
     * 
     * @type {UnresolvedVendorErrorCodeStatus}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    status: UnresolvedVendorErrorCodeStatus;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    remark: string;
    /**
     * 
     * @type {number}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    vendorErrorCodeId?: string | null;
    /**
     * 
     * @type {VendorErrorCodeManufacturerSummaryDto}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    manufacturer?: VendorErrorCodeManufacturerSummaryDto;
    /**
     * 
     * @type {VendorErrorCodeAssetTypeSummaryDto}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    assetType?: VendorErrorCodeAssetTypeSummaryDto;
    /**
     * 
     * @type {Date}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof UnresolvedVendorErrorCodeResponseDto
     */
    updatedAt: Date;
}



/**
 * Check if a given object implements the UnresolvedVendorErrorCodeResponseDto interface.
 */
export function instanceOfUnresolvedVendorErrorCodeResponseDto(value: object): value is UnresolvedVendorErrorCodeResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('manufacturerId' in value) || value['manufacturerId'] === undefined) return false;
    if (!('assetTypeId' in value) || value['assetTypeId'] === undefined) return false;
    if (!('errorCode' in value) || value['errorCode'] === undefined) return false;
    if (!('firstSeenAt' in value) || value['firstSeenAt'] === undefined) return false;
    if (!('lastSeenAt' in value) || value['lastSeenAt'] === undefined) return false;
    if (!('occurrenceCount' in value) || value['occurrenceCount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('remark' in value) || value['remark'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function UnresolvedVendorErrorCodeResponseDtoFromJSON(json: any): UnresolvedVendorErrorCodeResponseDto {
    return UnresolvedVendorErrorCodeResponseDtoFromJSONTyped(json, false);
}

export function UnresolvedVendorErrorCodeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnresolvedVendorErrorCodeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'manufacturerId': json['manufacturerId'],
        'assetTypeId': json['assetTypeId'],
        'errorCode': json['errorCode'],
        'matchType': json['matchType'] == null ? undefined : json['matchType'],
        'matchKey': json['matchKey'] == null ? undefined : json['matchKey'],
        'vendorErrorCode': json['vendorErrorCode'] == null ? undefined : json['vendorErrorCode'],
        'info': json['info'] == null ? undefined : json['info'],
        'parameter': json['parameter'] == null ? undefined : VendorErrorParameterFromJSON(json['parameter']),
        'state': json['state'] == null ? undefined : VendorErrorStateFromJSON(json['state']),
        'impactedComponent': json['impactedComponent'] == null ? undefined : VendorErrorImpactedComponentFromJSON(json['impactedComponent']),
        'category': json['category'] == null ? undefined : VendorErrorCategoryFromJSON(json['category']),
        'severity': json['severity'] == null ? undefined : VendorErrorSeverityFromJSON(json['severity']),
        'firmwareVersion': json['firmwareVersion'] == null ? undefined : json['firmwareVersion'],
        'description': json['description'] == null ? undefined : json['description'],
        'sourceDescription': json['sourceDescription'] == null ? undefined : json['sourceDescription'],
        'firstSeenAt': (new Date(json['firstSeenAt'])),
        'lastSeenAt': (new Date(json['lastSeenAt'])),
        'occurrenceCount': json['occurrenceCount'],
        'status': UnresolvedVendorErrorCodeStatusFromJSON(json['status']),
        'remark': json['remark'],
        'version': json['version'],
        'vendorErrorCodeId': json['vendorErrorCodeId'] == null ? undefined : json['vendorErrorCodeId'],
        'manufacturer': json['manufacturer'] == null ? undefined : VendorErrorCodeManufacturerSummaryDtoFromJSON(json['manufacturer']),
        'assetType': json['assetType'] == null ? undefined : VendorErrorCodeAssetTypeSummaryDtoFromJSON(json['assetType']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function UnresolvedVendorErrorCodeResponseDtoToJSON(json: any): UnresolvedVendorErrorCodeResponseDto {
    return UnresolvedVendorErrorCodeResponseDtoToJSONTyped(json, false);
}

export function UnresolvedVendorErrorCodeResponseDtoToJSONTyped(value?: UnresolvedVendorErrorCodeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'manufacturerId': value['manufacturerId'],
        'assetTypeId': value['assetTypeId'],
        'errorCode': value['errorCode'],
        'matchType': value['matchType'],
        'matchKey': value['matchKey'],
        'vendorErrorCode': value['vendorErrorCode'],
        'info': value['info'],
        'parameter': VendorErrorParameterToJSON(value['parameter']),
        'state': VendorErrorStateToJSON(value['state']),
        'impactedComponent': VendorErrorImpactedComponentToJSON(value['impactedComponent']),
        'category': VendorErrorCategoryToJSON(value['category']),
        'severity': VendorErrorSeverityToJSON(value['severity']),
        'firmwareVersion': value['firmwareVersion'],
        'description': value['description'],
        'sourceDescription': value['sourceDescription'],
        'firstSeenAt': value['firstSeenAt'].toISOString(),
        'lastSeenAt': value['lastSeenAt'].toISOString(),
        'occurrenceCount': value['occurrenceCount'],
        'status': UnresolvedVendorErrorCodeStatusToJSON(value['status']),
        'remark': value['remark'],
        'version': value['version'],
        'vendorErrorCodeId': value['vendorErrorCodeId'],
        'manufacturer': VendorErrorCodeManufacturerSummaryDtoToJSON(value['manufacturer']),
        'assetType': VendorErrorCodeAssetTypeSummaryDtoToJSON(value['assetType']),
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

